<template>
    <div class="row">
        <input-select class="col-12" label="Tipo de viagem" v-model="form.tipo" :options="options.tipos" ref="tipo" required/>
        <input-textarea class="col-12" label="Detalhamento" v-model="form.detalhamento" ref="detalhamento" required/>
        <input-textarea class="col-12" label="Justificativa" v-model="form.justificativa" ref="justificativa" required/>
        <input-money class="col-12 col-md-3" label="Valor R$" v-model="form.valorUnitario" ref="valor" required/>
        <input-text class="col-12 col-md-3" type="number" label="Quantidade" v-model="form.quantidade" ref="quantidade" required/>
        <input-text readonly class="col-12 col-md-3" label="Valor Total R$" v-model="valor" ref="valorTotal" required/>
        <input-select class="col-12 col-md-3" label="Mês da despesa" :options="mesesDepesas" v-model="form.mes" ref="mes" required/>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputMoney from "@/components/inputs/InputMoney";

import {FormMixin} from "@/common/mixins/FormMixin";

import helpers from "@/common/utils/helpers";

export default {
    name: "VD",
    mixins: [FormMixin],
    props: {
        projeto : {
            type: Object,
            default: null
        },
        form : {
            type: Object,
            default: null
        }
    },
    components: {
        InputSelect,
        InputText,
        InputTextarea,
        InputMoney
    }, 
    data : () =>({
        options : {
            tipos: helpers.getPGViagemDiaria()
        },
    }),
    computed:{
        mesesDepesas(){
            let projeto = this.telaProponente ? this.projeto : this.projeto.projetoGestao;
            return helpers.criarArrayMes(`${projeto.anoInicio}-04-01`,projeto.duracao, true);
        },
        valor : {
            get : function(){
                return helpers.formatarValor((this.form.valorUnitario ? this.form.valorUnitario.toString().replace('R$ ','').replace(/\./g, '').replace(',', '.') : 0) * this.form.quantidade);
            },
            set : function(value){
                this.form.valor = value;
            }
        },
        telaProponente :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento'
        },
    },
}
</script>
<style lang="">
    
</style>